import _ from 'lodash';
import axios from 'axios';

let recoveringAPI = 'catalogosingredientes/indexinlist'

let indexNutritional = []

let ingObj2Array = (ingObj) => {
    let arr = []
    _.forEach(ingObj, ing => {
        arr.push(ing.id_ingrediente_fk)
    })
    return arr;
};

let isIngredientNutritionalyValidated = (id_pk) => {
    let indexInList = _.findIndex(indexNutritional, {id_pk})
    if(indexInList == -1)
        return false;
    return (indexNutritional[indexInList].estatus_nutricional == 'Revisado')
}

let recoverNutritionalStatus = async (ingObj) => {
    try {
        const   ingArr = ingObj2Array(ingObj),
                response = await axios.get(recoveringAPI + '/' + ingArr.join(','));

        // RESPONSE REVISIÓN
        if(!response.status){
            throw response.msg;
        }

        // RETURN INDEX
        indexNutritional = _.map(response.data, (item) => {
            item.id_pk = parseInt(item.id_pk)
            return item
        });

        return indexNutritional

    } catch(e) {
        console.error(e)
        indexNutritional = []
        return []
    }
};

let computedGeneralValidation = (data2work) => {
    let response = true;
    _.forEach(data2work, item => {
        if(!isIngredientNutritionalyValidated(item.id_ingrediente_fk)){
            response = false;
        }
    })
    return response
}

export {recoverNutritionalStatus, ingObj2Array, isIngredientNutritionalyValidated, computedGeneralValidation}